
export class Pet {
    constructor(
        public id: number = null,
        public name: string = '',
        public petTypeId: number = null,
        public petTypeName: string = '',
        public weight: string = '',
        public height: string = '',
        public dateOfBirth: string = '',
        public moveOutDate: string = '',
        public breed: string = '',
        public note: string = '',
        public suiteId: number = null,
        public suiteNumber: string = '',
        public buildingId: number = null,
        public buildingName: string = '',
        public checked: boolean = false,
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public formFields = {
            name: {editMode: false},
            petTypeId: {editMode: false},
            weight: {editMode: false},
            height: {editMode: false},
            dateOfBirth: {editMode: false},
            breed: {editMode: false},
            note: {editMode: false},
        }
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/Pet.ts